import i18next from 'i18next';
/**
 * SecurityMeasure Integration
 * Generated by AI
 */
import { toast } from 'sonner';
import { getIntegrationErrorMessage } from '@/lib/integration-error-message.js';
// TODO: Check store import
// import { useSecurityMeasureStore } from '@/store/security-measure.store.js';
import { Logger } from '@/lib/app-log.js';

export class SecurityMeasureIntegration {
    constructor(sdkService) {
        this.service = sdkService;
    }

    async fetchAll(params = {}) {
        /*
        const store = useSecurityMeasureStore.getState();
        store.setLoading(true);
        */
        try {
            const response = await this.service.getAll(params);
            
            /*
            store.setItems(response.data);
            if (response.pagination) store.setPagination(response.pagination);
            */
            
            return { success: true, data: response.data };
        } catch (error) {
            toast.error(getIntegrationErrorMessage(error));
            /* store.setError(error.message); */
            return { success: false, error: getIntegrationErrorMessage(error) };
        } finally {
            /* store.setLoading(false); */
        }
    }

    async getById(id) {
        try {
            const response = await this.service.getById(id);
            return { success: true, data: response.data };
        } catch (error) {
            toast.error(getIntegrationErrorMessage(error));
            return { success: false, error: getIntegrationErrorMessage(error) };
        }
    }

    async create(data) {
        try {
            const response = await this.service.create(data);
            toast.success(i18next.t('integrationToasts:createdSuccessfully', { defaultValue: 'Created successfully' }));
            return { success: true, data: response.data };
        } catch (error) {
            toast.error(getIntegrationErrorMessage(error));
            return { success: false, error: getIntegrationErrorMessage(error) };
        }
    }

    async update(id, data) {
        try {
            const response = await this.service.update(id, data);
            toast.success(i18next.t('integrationToasts:updatedSuccessfully', { defaultValue: 'Updated successfully' }));
            return { success: true, data: response.data };
        } catch (error) {
            toast.error(getIntegrationErrorMessage(error));
            return { success: false, error: getIntegrationErrorMessage(error) };
        }
    }

    async delete(id) {
        try {
            await this.service.delete(id);
            toast.success(i18next.t('integrationToasts:deletedSuccessfully', { defaultValue: 'Deleted successfully' }));
            return { success: true };
        } catch (error) {
            toast.error(getIntegrationErrorMessage(error));
            return { success: false, error: getIntegrationErrorMessage(error) };
        }
    }
}
